import styles from './styles.module.css'
import { memo, useState } from 'react'
import { PopoverIcon } from '@/components/ui/icons'

const Popover = ({ info }) => {
  const [isOpened, setIsOpened] = useState(false)

  return (
    <div className={styles.popoverContainer}>
      <div
        className={styles.iconContainer}
        onMouseEnter={() => setIsOpened(true)}
        onMouseLeave={() => setIsOpened(false)}
      >
        <PopoverIcon />
      </div>
      {isOpened && (
        <div className={styles.popoverPopup}>
          <div className={styles.popoverText}>{info}</div>
        </div>
      )}
    </div>
  )
}

export default memo(Popover)
